module.exports = __webpack_public_path__ + "static/media/website_full.86d13cf5eef14bbba1ad6bc0125b4fa9.svg";